import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-165">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/oFZLzufyycXsQx54nsD56C/ChatGPT_Image_Jun_23,_2026_at_11_03_08_AM.png")',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-166">
        {/* Subtle dark navy overlay (≈45%) keeps headline & buttons readable */}
        <div className="absolute inset-0 bg-navy/45" data-id="element-167" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/30 via-navy/10 to-navy/70" data-id="element-168" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mt-16" data-id="element-169">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-center" data-id="element-170">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif text-white font-bold mb-6 leading-tight max-w-4xl" data-id="element-171">
            Nationwide Moving Services You Can Trust
          </h1>

          <p className="text-lg md:text-xl text-gray-light mb-4 max-w-2xl font-light leading-relaxed" data-id="element-172">
            Based in Dallas, Texas • Serving All 50 States
          </p>

          <p className="text-xl md:text-2xl font-serif italic text-gold mb-10 max-w-2xl leading-relaxed" data-id="element-173">
            More Than Moving Boxes—We're Moving Lives Forward.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-174">
            <a href="#contact" className="bg-gold hover:bg-gold-light text-navy font-semibold px-8 py-4 rounded transition-colors text-center text-lg" data-id="element-175">
              Get a Free Quote
            </a>
            <a href="tel:5551234567" className="bg-transparent border-2 border-white hover:bg-white hover:text-navy text-white font-semibold px-8 py-4 rounded transition-colors text-center text-lg" data-id="element-176">
              Call Now
            </a>
          </div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10" animate={{
      y: [0, 10, 0]
    }} transition={{
      repeat: Infinity,
      duration: 2
    }} data-id="element-177">
        <a href="#services" className="text-white/70 hover:text-gold transition-colors flex flex-col items-center gap-2" data-id="element-178">
          <span className="text-xs uppercase tracking-widest" data-id="element-179">Scroll</span>
          <div className="w-[1px] h-12 bg-gradient-to-b from-white/70 to-transparent" data-id="element-180" />
        </a>
      </motion.div>
    </section>;
}